// extracted by mini-css-extract-plugin
export default {"modalWrapper":"AddToCartModal_modalWrapper__JWOan","textWrapper":"AddToCartModal_textWrapper__CVUrT"};